import styled from "@emotion/styled";
export const StyledPersonTextualInfo = styled.div`
  font-size: 1.125rem;
  line-height: 30px;

  .person-name {
    font-weight: 700;
  }

  @media (max-width: 720px) {
    font-size: 1rem;
    line-height: 30px;
  }
`;
